import * as yup from "yup";

export const pathSchema = yup.object({
  id: yup.string().required(),
  name: yup.string().notRequired(),
});
